import { useEffect, useRef } from 'react';
import { io } from 'socket.io-client';
import { useAuthStore } from 'store';

const SOCKET_SERVER_URL = process.env.REACT_APP_SOCKET_IO_SUBSCRIPTION; // Replace with your socket server URL

const transports = ['websocket'];

export const useSocketSubscription = (cb: (data: any) => void) => {
  const { token } = useAuthStore();
  const socketRef = useRef<any>(null);
  const paymentIdRef = useRef<any>(null);

  console.log('deployed 3');

  useEffect(() => {
    // Create a new socket instance
    if (!token) {
      return;
    }
    if (socketRef.current) {
      socketRef.current.disconnect();
    }

    const socketInstance = io(SOCKET_SERVER_URL, {
      transports,
      path: '/socket.io',
      query: { authorization: `Bearer ${token}` }
    });

    socketInstance.on('connect', () => {
      console.log('connect socket');
      socketInstance.emit('listenUser');
    });

    socketInstance.on('setup_intent.succeeded', (data: any) => {
      if (cb) {
        if (paymentIdRef.current !== data?.data?.userPaymentMethodId) {
          cb(data);
        }
        paymentIdRef.current = data?.data?.userPaymentMethodId;
      }
    });

    socketInstance.on('gateway-error', (err: any) => {
      console.log('err socket: ', err);
    });

    socketInstance.on('disconnect', () => {
      console.log('disconnect socket');
      socketInstance.removeAllListeners();
      socketInstance.disconnect();
    });

    // Set the socket in state
    socketRef.current = socketInstance;

    // Clean up on unmount
    return () => {
      socketRef.current?.disconnect();
    };
  }, [token]);

  return socketRef.current;
};
